<template>
  <section>
    <nav :class="{ collapse: isCollapsed }" class="bd-links">
      <div
        v-for="n of nav"
        :key="n.root"
        v-if="!n.isHidden && isVisible(n.pages)"
        class="bd-toc-item"
        :class="{ active: n.isActive }"
        @click="isActive(n)"
      >
        <a class="bd-toc-link" href="#">
          {{ n.root }}
        </a>
        <ul class="nav bd-sidenav">
          <router-link exact tag="li" :to="p.url" v-for="p of n.pages" :key="p.name" v-if="!p.isHidden && isAllowed(p.url)">
            <a href="#" v-if="p.url === '/calibrates'" :data-testid="p.name">
              <i :class="p.icon"></i>
              <span>{{ p.name }}</span>
              <span class="badge-incoming" v-if="incomingCount > 0" title="# submitted requests">{{ incomingCount }}</span>
              <span class="badge-unread" v-if="unreadCount > 0" title="# unread chats">{{ unreadCount }}</span>
            </a>
            <a href="#" v-else :data-testid="p.name">
              <i :class="p.icon"></i>
              <span>{{ p.name }}</span>
            </a>
          </router-link>
        </ul>
      </div>
      <div class="bd-toc-item active">
        <ul class="nav bd-sidenav">
          <li v-for="s of navSupport" :key="s.name">
            <button type="button" class="custom-button" @click="performAction(s.action)">
              <i :class="s.icon"></i>
              <span>{{ s.name }}</span>
            </button>
          </li>
        </ul>
      </div>
    </nav>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'nav-left',
  data() {
    return {
      searchText: '',
      isCollapsed: true,
      nav: [],
      navSupport: []
    }
  },
  mounted() {
    this.initMenu()
  },
  computed: {
    ...mapGetters('auth', ['profile', 'isAllowed']),
    ...mapGetters('chat', ['unreadCount']),
    ...mapGetters('calibrates', ['calibrateCounts']),
    ...mapGetters('locations', ['dispatchedTechs', 'preferences']),
    isHost() {
      let _is = false
      if ([1, 2].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    isAdmin() {
      let _is = false
      if ([1, 2, 3, 5, 7, 9, 12].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    isShop() {
      let _is = false
      if ([15, 16, 17].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    isCenter() {
      let _is = false
      if ([12, 14].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    isDispatch() {
      let _is = false
      if ([10, 13].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    isDivision() {
      let _is = false
      if ([5].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    isDivisionOrPartnerUser() {
      let _is = false
      if ([6, 11].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    isDispatched() {
      let _is = false
      if (this.preferences.length > 0) {
        let item = this.preferences.filter(x => x.name === 'DispatchApproach')
        console.log('DispatchApproach', item)
        if (item.length > 0) {
          _is = item[0].value === '1'
        }
      }
      return _is
    },
    incomingCount() {
      let _count = 0
      console.log('Incoming Counts', this.calibrateCounts)
      if (this.calibrateCounts !== undefined && this.calibrateCounts !== null) {
        _count = this.calibrateCounts.submitted !== null ? this.calibrateCounts.submitted : 0
      }
      return _count
    },
    isSchedule() {
      let _is = true
      if (this.dispatchedTechs) {
        if (parseInt(this.dispatchedTechs.countDispatched) > 0) {
          _is = false
        }
      }
      if (this.isDispatched) {
        _is = false
      }
      return _is
    }
  },
  methods: {
    ...mapActions('chat', ['quitChat']),
    ...mapActions('auth', ['clearToken']),
    ...mapActions('locations', ['getDispatchedTechs', 'getPreferences']),
    async initMenu() {
      this.nav = []
      let pages = []
      await this.getDispatchedTechs({
        firm: this.profile.firm,
        countOnly: true
      })
      await this.getPreferences({
        firm: this.profile.firm,
        category: 'Dispatch',
        name: 'DispatchApproach'
      })
      if (this.isAdmin || this.isHost) {
        pages = [
          { url: '/', name: 'Home', icon: '' },
          {
            url: '/locations',
            name: 'Locations',
            icon: 'fas fa-map-marker-alt'
          },
          {
            url: '/calibrates/Submitted',
            name: 'Incoming ROs',
            icon: 'fas fa-sign-in-alt'
          },
          {
            url: '/calibrates',
            name: 'Calibrate ROs',
            icon: 'fas fa-tachometer-alt'
          },
          // {
          //   url: '/location-requests',
          //   name: 'Calibrate Requests',
          //   icon: 'fas fa-folder-plus'
          // },
          {
            url: '/dispatch',
            name: 'Dispatch',
            icon: 'fas fa-shipping-fast'
          },
          {
            url: '/insurance',
            name: 'Insurance',
            icon: 'fas fa-shield-alt'
          },
          { url: '/fleet', name: 'Fleet', icon: 'fas fa-truck' },
          { url: '/storage', name: 'Storage', icon: 'fas fa-database' }
        ]
        pages.push({
          url: '/techschedule',
          name: 'Tech Schedule',
          icon: 'far fa-calendar-alt'
        })
        if (this.isHost) {
          pages.push({
            url: '/chatadmin',
            name: 'Chat Admin',
            icon: 'fas fa-cogs'
          })
        }
        if (this.isAdmin) {
          pages.push({
            url: '/widgetdemo',
            name: 'Widget Demo',
            icon: 'fa fa-window-maximize'
          })
        }
        pages.push({
          url: '/dashboard',
          name: 'Dashboard',
          icon: 'fas fa-chart-line'
        })
        // pages = pages.concat([
        //   {
        //     url: '/chatadmin',
        //     name: 'Chat Admin',
        //     icon: 'fas fa-cogs'
        //   },
        //   {
        //     url: '/dashboard',
        //     name: 'Dashboard',
        //     icon: 'fas fa-chart-line'
        //   }
        // ])
        this.nav = [
          {
            root: '',
            isActive: true,
            pages: pages
          }
        ]
      } else if (this.isCenter) {
        pages = [
          { url: '/', name: 'Home', icon: '' },
          {
            url: '/calibrates/Submitted',
            name: 'Incoming ROs',
            icon: 'fas fa-sign-in-alt'
          },
          {
            url: '/calibrates',
            name: 'Calibrate ROs',
            icon: 'fas fa-tachometer-alt'
          },
          {
            url: '/techschedule',
            name: 'Tech Schedule',
            icon: 'far fa-calendar-alt'
          }
          // {
          //   url: '/location-requests',
          //   name: 'Calibrate Requests',
          //   icon: 'fas fa-folder-plus'
          // }
        ]
        if (this.isSchedule) {
          pages.push({
            url: '/schedule',
            name: 'View Schedule',
            icon: 'far fa-calendar-alt'
          })
        }
        pages = pages.concat([
          { url: '/fleet', name: 'Fleet', icon: 'fas fa-truck' },
          {
            url: '/insurance',
            name: 'Insurance',
            icon: 'fas fa-shield-alt'
          },
          {
            url: '/dashboard',
            name: 'Dashboard',
            icon: 'fas fa-chart-line'
          },
          {
            url: '/locations',
            name: 'Locations',
            icon: 'fas fa-map-marker-alt'
          },
          {
            url: '/tech-requests',
            name: 'RO Map View',
            icon: 'fas fa-map-marked-alt'
          }
        ])
        this.nav = [
          {
            root: '',
            isActive: true,
            pages: pages
          }
        ]
      } else if (this.isDispatch) {
        pages = [
          { url: '/', name: 'Home', icon: '' },
          {
            url: '/dispatch',
            name: 'Dispatch',
            icon: 'fas fa-shipping-fast'
          },
          {
            url: '/calibrates',
            name: 'Calibrate ROs',
            icon: 'fas fa-tachometer-alt'
          }
        ]
        pages.push({
          url: '/techschedule',
          name: 'Tech Schedule',
          icon: 'far fa-calendar-alt'
        })
        if (this.isSchedule) {
          pages.push({
            url: '/schedule',
            name: 'View Schedule',
            icon: 'far fa-calendar-alt'
          })
        }
        pages = pages.concat([
          {
            url: '/locations',
            name: 'Locations',
            icon: 'fas fa-map-marker-alt'
          }
        ])
        this.nav = [
          {
            root: '',
            isActive: true,
            pages: pages
          }
        ]
      } else if (this.isDivision) {
        pages = [
          { url: '/', name: 'Home', icon: '' },
          {
            url: '/locations',
            name: 'Location',
            icon: 'fas fa-map-marker-alt'
          }
        ]
        if (this.isSchedule) {
          pages.push({
            url: '/schedule',
            name: 'View Schedule',
            icon: 'far fa-calendar-alt'
          })
        }
        pages = pages.concat([
          {
            url: '/calibrates/Pending',
            name: 'Pending Requests',
            icon: 'fas fa-sign-in-alt'
          },
          {
            url: '/calibrates/Submitted',
            name: 'In Process Requests',
            icon: 'fas fa-sign-in-alt'
          },
          {
            url: '/calibrates',
            name: 'Calibrate ROs',
            icon: 'fas fa-tachometer-alt'
          },
          {
            url: '/dispatch',
            name: 'Dispatch',
            icon: 'fas fa-shipping-fast'
          },
          { url: '/fleet', name: 'Fleet', icon: 'fas fa-truck' },
          {
            url: '/insurance',
            name: 'Insurance',
            icon: 'fas fa-shield-alt'
          }
        ])
        this.nav = [
          {
            root: '',
            isActive: true,
            pages: pages
          }
        ]
      } else if (this.isDivisionOrPartnerUser) {
        pages = [{ url: '/', name: 'Home', icon: '' }]
        pages = pages.concat([
          {
            url: '/calibrates/Pending',
            name: 'Pending Requests',
            icon: 'fas fa-sign-in-alt'
          },
          {
            url: '/calibrates/Submitted',
            name: 'In Process Requests',
            icon: 'fas fa-sign-in-alt'
          },
          {
            url: '/calibrates',
            name: 'Calibrate ROs',
            icon: 'fas fa-tachometer-alt'
          },
          {
            url: '/dispatch',
            name: 'Dispatch',
            icon: 'fas fa-shipping-fast'
          },
          {
            url: '/tech-requests',
            name: 'RO Map View',
            icon: 'fas fa-map-marked-alt'
          },
          {
            url: '/techschedule',
            name: 'Tech Schedule',
            icon: 'far fa-calendar-alt'
          },
          { url: '/fleet', name: 'Fleet', icon: 'fas fa-truck' },
          {
            url: '/insurance',
            name: 'Insurance',
            icon: 'fas fa-shield-alt'
          },
          { url: '/storage', name: 'Storage', icon: 'fas fa-database' },
          {
            url: '/users',
            name: 'Users',
            icon: 'fas fa-users-cog'
          }
        ])
        this.nav = [
          {
            root: '',
            isActive: true,
            pages: pages
          }
        ]
      } else {
        pages = [{ url: '/', name: 'Home', icon: '' }]
        if (this.isSchedule) {
          pages.push({
            url: '/schedule',
            name: 'View Schedule',
            icon: 'far fa-calendar-alt'
          })
        }
        pages = pages.concat([
          {
            url: '/calibrates/Pending',
            name: 'Pending Requests',
            icon: 'fas fa-sign-in-alt'
          },
          {
            url: '/calibrates/Submitted',
            name: 'In Process Requests',
            icon: 'fas fa-sign-in-alt'
          },
          {
            url: '/calibrates',
            name: 'Calibrate ROs',
            icon: 'fas fa-tachometer-alt'
          },
          {
            url: '/techschedule',
            name: 'Tech Schedule',
            icon: 'far fa-calendar-alt'
          },
          { url: '/fleet', name: 'Fleet', icon: 'fas fa-truck' },
          {
            url: '/insurance',
            name: 'Insurance',
            icon: 'fas fa-shield-alt'
          }
        ])
        this.nav = [
          {
            root: '',
            isActive: true,
            pages: pages
          }
        ]
      }
      console.log('schedule settings', {
        isSchedule: this.isSchedule,
        isDispatch: this.isDispatch,
        isAdmin: this.isAdmin,
        isCenter: this.isCenter,
        isDivisionOrPartnerUser: this.isDivisionOrPartnerUser,
        nav: this.nav
      })
      if (this.isSchedule === false && (!this.isDispatch && !this.isAdmin && !this.isCenter && !this.isDivisionOrPartnerUser)) {
        this.nav[0].pages = this.nav[0].pages.filter(x => x.url !== '/schedule' && x.url !== '/techschedule')
        console.log('Filtering nav')
      }
      this.navSupport = [
        { name: 'About', icon: '', action: 'about' },
        { name: 'Training Assets', icon: '', action: 'videos' },
        { name: 'Notify! CoPilot Setup', icon: '', action: 'notifications' },
        // { name: 'Privacy Policy', icon: '', action: 'privacy' },
        { name: 'Logout', icon: '', action: 'logout' }
      ]
    },
    isActive(nav) {
      return true
    },
    isVisible(pages) {
      return pages.some(p => this.isAllowed(p.url))
    },
    search() {
      this.isCollapsed = false
      for (let n of this.nav) {
        n.isHidden = false
        let count = 0
        for (let p of n.pages) {
          p.isHidden = !p.name.toLowerCase().includes(this.searchText.toLowerCase())
          if (!p.isHidden) {
            count++
          }
        }
        n.isHidden = !count
      }
      this.$forceUpdate()
    },
    performAction(action) {
      if (action === 'about') {
        this.$router.push('/about')
      } else if (action === 'logout') {
        this.quitChat()
        this.clearToken()
        window.location.assign('/')
      } else if (action === 'privacy') {
        window.open('https://www.calcopilot.com/pages/privacy-policy', '_blank')
      } else if (action === 'videos') {
        window.open('https://www.calcopilot.com/MCPtrngdocs', '_blank')
      } else if (action === 'notifications') {
        this.$router.push('/notifications')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.badge-incoming {
  position: relative;
  top: -5px;
  display: inline-flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  color: white;
  background: darkgreen;
  position: relative;
  box-sizing: border-box;
  text-align: center;
  vertical-align: middle;
  font-weight: normal;
  font-size: 12px;
  border-radius: 18px;
  padding: 0 4px;
  height: 18px;
  min-width: 18px;
}
.custom-button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 10px 20px;
  border: none;
  background: none;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  i {
    margin-right: 10px;
  }
  &:hover {
    color: #007bff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/nav-left.vue